// PosParamsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const PosParamsContext = createContext();

export const PosParamsProvider = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [params, setParams] = useState({
    lat: searchParams.get('lat'),
    lng: searchParams.get('lng'),
  });

  useEffect(() => {
    setParams({
      lat: searchParams.get('lat'),
      lng: searchParams.get('lng'),
    });
  }, [location.search, searchParams]);

  return (
    <PosParamsContext.Provider value={params}>
      {children}
    </PosParamsContext.Provider>
  );
};

export const usePosParams = () => {
  return useContext(PosParamsContext);
};
